const PerfilPermissionamentoEnum = Object.freeze({
    ADMINISTRADOR: 1,
    ADMINISTRADOR_BALANCO: 87,
    ADMINISTRADOR_DE_TI: 114,
    FATURAMENTO: 120,
});

const PerfilAdminEnum = Object.freeze({
    ADMINISTRADOR: 1,
    ADMINISTRADOR_BALANCO: 87,
    ADMINISTRADOR_BALANCO_2: 96,
    ADMINISTRADOR_DE_TI: 114,
    FATURAMENTO: 120,
});

function isAdmin(perfilId) {
    const admin = Object.values(PerfilAdminEnum);
    if(admin.includes(perfilId)) {
        return true;
    }

    return false;
}

export { isAdmin };

export default PerfilPermissionamentoEnum;



// WEBPACK FOOTER //
// ./src/enums/PerfilPermissionamentoEnum.js